// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"077ad9cc","230":"6def32f7","453":"ae32a3cc","566":"f782fe3a","607":"6d09765b"}[chunkId] + ".chunk.js";
};